export default __webpack_public_path__ + "static/media/component003Boss-right.d1c8cd18.png";